import React from 'react';


import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import CloseIcon from '@material-ui/icons/Close';
import UserIcon from '@material-ui/icons/Person';
import FileIcon from '@material-ui/icons/InsertDriveFileOutlined';
import TextField from '@material-ui/core/TextField';

import { FORM } from '../../constants/strings/StringsDashboard';
// import { List } from '@material-ui/core';

function getDocs(list, user) {
  const result = list.filter(l => l.userId === user)
  return result[0].documents
}

function FileModalComponent(props) {
  return (
    <>
      <div className="file-modal" >
        <div className="header-modal">
          <div ><FolderOpenIcon className="color-white" /></div>
          <div ><p className='unselectable color-white'>{FORM.OPEN_FILE}</p></div>
          <div ><CloseIcon className="close-icon" onClick={props.onCancel} /></div>
        </div>
        <div className='text-center margin-top-20px select-user-row'>
          <div></div>
          <div className="user-icon"><UserIcon className="user-circle" /></div>
          <div><label className="user-text unselectable">{FORM.USER}:</label></div>
          <div>
            <FormControl variant="outlined" className="input-select user-select">
              <Select
                value={props.userValue}
                onChange={(event) => props.onSelectUser(event, 'open')}
                input={
                  <OutlinedInput
                    name="user"
                    id="outlined-age-simple"
                  />
                }
              >
                {/* <MenuItem value="">
                                    <em>{'Seleccionar Usuario'}</em>
                                </MenuItem> */}
                {
                  props.userList.map((op, i) => {
                    return <MenuItem value={op.userId} key={'menu-item-user-' + i}>{op.name + ' ' + op.lastName + ' (' + op.user + ')'}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
          </div>
          <div></div>
        </div>
        <br />
        <div className="list-container ">
          <div className={'header-file-list'}>
            <div className='unselectable'>{FORM.NAME}</div>
            <div className='unselectable'>{FORM.DATE}</div>
          </div>
          <div className="container-file-list">
            {
              getDocs(props.userList, props.userValue).map((op, i) => {
                return (
                  <div className={(op.id === props.fileValue) ? 'item-file-list unselectable file-selected' : 'item-file-list unselectable'}
                    onClick={() => props.onClickFile({ target: { value: op.id, name: op.name } }, 'open')}
                    onDoubleClick={() => props.onBoubleClickFile({ target: { value: op.id, name: op.name } }, 'open')}
                    key={'menu-item-file-' + i}>
                    <div className=""><FileIcon /></div>
                    <div className="">{op.name}</div>
                    <div className="">{op.createdAt.split('T')[0] + ' ' + op.createdAt.split('T')[1].split('.')[0]}</div>
                  </div>
                )
              })
            }
          </div>
        </div>
        <br />
        <div className="text-center">
          <label className='unselectable'>{FORM.NAME}: </label>
          <TextField
            value={props.fileText}
            className={'input-select file-select'}
            margin="normal"
            variant="outlined"
            onChange={props.onChangeText('open')}
          />
        </div>
        <div className="footer-modal">
          <button className="btn-area btn-area-green" onClick={props.onOpen}>{FORM.OPEN}</button>
          <button className="btn-area btn-area-grey" onClick={props.onCancel}>{FORM.CANCEL}</button>
        </div>
      </div>
    </>
  )
}

export default FileModalComponent;